import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ng9ab9u9tu: FaireBrandEntity = {
  token: "b_ng9ab9u9tu",
  type: "brand",
  name: "Voyager Silk - Silk Scarves",
  avatarUrl:
    "https://cdn.faire.com/fastly/a1c149272955d08f76906ab53dd67e35f7e328ca44dd6d2c54a6f7f93c87e510.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/668a37837df399d26f4d4298fb788265aec3f7e9f6f11b2efba63fcb29252edb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a1c149272955d08f76906ab53dd67e35f7e328ca44dd6d2c54a6f7f93c87e510.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/668a37837df399d26f4d4298fb788265aec3f7e9f6f11b2efba63fcb29252edb.png",
  location: "Vineyard Haven, MA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi, my name’s Elissa Turnbull. I make these scarves for you, the Voyager. They’re designed for a little adventure in your everyday, something to wear that shows you’re charting your own way.\n\nBefore I designed scarves, I learned about voyaging in a literal way. I once lived in a Portuguese shipyard helping rebuild a steel boat that had been burned, flooded, and abandoned for decades. The vision was to turn her into a sailing cargo ship to bring supplies between Hawaii and the Marshall Islands, which eventually did happen. We brought her across the Atlantic to America, where no investors came and the 170 tonnes of cobblestones we’d hauled to sell didn’t move. One turn of the compass led to another, which is how I ended up here, in Martha’s Vineyard.\n\nI’m also an illustrator, which is its own kind of voyage. I draw stories, characters, places, and moods, and that practice shapes how I think about color and pattern. Those instincts flow straight into Voyager Silk.\n\nThis project is another chapter in a long chain of voyages. I hope these scarves come along with you wherever you’re headed next.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.856Z",
    importedBy: "entity-db-cli",
  },
};
